export const SectionLabel = ({ children, className = '' }) => (
  <span className={`inline-block text-xs font-semibold uppercase tracking-widest text-[hsl(var(--sss-teal))] mb-3 ${className}`}>
    {children}
  </span>
);
